import { ReactElement } from 'react';
import { Tag } from 'antd';

import { TagListPanelProps } from './interfaces';
import styles from './styles.module.css';

export const TagListPanel = ({ items, emptyText, header, onRemove }: TagListPanelProps): ReactElement => {
  if (!items.length) {
    return (
      <div className={styles.panel}>
        <div className={styles.empty}>{emptyText}</div>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      {header !== undefined && <div className={styles.header}>{header}</div>}
      <div className={styles.list}>
        {items.map(({ key, label }) => (
          <Tag
            key={key}
            closable={Boolean(onRemove)}
            onClose={e => {
              e.preventDefault();
              onRemove?.(key);
            }}
          >
            {label}
          </Tag>
        ))}
      </div>
    </div>
  );
};
